import "./StatusTokens.scss";

const StatusToken = ({ label, children, type, onClick, style }) => {
	return <div onClick={onClick} className={`status-token-outer${type ? " type-" + type : ""}`} style={style} ><h5>{label || children}</h5></div>;
}

export default StatusToken;